import { EventAction } from './eventAction';
import { EventFile } from './eventFile';
import { Participant } from './participant';
import { RemovalVoting } from './removalVoting';

export class Event {
    constructor(
        public id: number | string,
        public posterId: number,
        public posterName: string,
        public name: string,
        public message: string,
        public dateStart: Date = new Date(),
        public dateEnd: Date = new Date(),
        public isAllDayLong: boolean = true,
        public relatedItems: EventFile[],
        public eventActions: EventAction[] = [],
        public participants: Participant[],
        public type:
            | 'event'
            | 'groupEvent'
            | 'exCommEvent'
            | 'conference'
            | 'groupOrder',
        public participationDeadline: Date | undefined = undefined,
        public isInProcess: boolean | undefined = undefined,
        public isInSubmitted: boolean | undefined = undefined,
        public groupOrderId: string | undefined = undefined,
        public isRecordingAvailable: boolean | undefined = false,
        public removalVoting: RemovalVoting | undefined = null,
        public colorSettings: EventColorSettings | undefined = null,
        public onClick?: () => void
    ) {}
}
export class EventColorSettings {
    constructor(
        public color: string,
        public backgroundColor: string,
        public activeColor: string,
        public activeBackgroundColor: string
    ) {}
}
